<template>
  <q-card-section v-bind="$attrs">
    <slot></slot>
  </q-card-section>
</template>
